<script setup lang="ts">
import {useI18n} from "vue-i18n";
import { useUnitConversion} from "~/composables/useUnitConversion";
const { locale  } = useI18n()
const localePath = useLocalePath()
const { convert } = useUnitConversion();

const props = defineProps({
  title: {
    type: String,
    default: "Records card",
  },
  subtitle: {
    type: String,
    default: "What is the record for?",
  },
  footer: {
    type: String,
    default: ''
  },
  data: {
    type: Array,
    default() {
      return []
    },
  },
  options: {
    type: Object,
    default() {
      return {
        date: {
          'year': "numeric",
          'month': "short",
          'day': "numeric",
        },
        unit: '&deg;F',
        link: '',
      }
    },
  },
});
</script>

<template>
  <v-card>
    <template
      #title
    >
      <span v-html="props.title" />
    </template>
    <template #subtitle>
      <span v-html="props.subtitle" />
    </template>
    <v-card-text class="ma-0 pa-0">
      <v-table density="compact">
        <tbody>
          <tr
            v-for="item in props.data"
            :key="item.id"
          >
            <td v-if="item.title instanceof Date">
              <NuxtLink
                v-if="props.options!.link === 'month'"
                :to="localePath(
                  item.title
                    .toLocaleDateString(locale, { month: 'long' })
                    .toLowerCase())
                "
              >
                {{
                  item.title.toLocaleDateString(locale, props.options.date)
                }}
              </NuxtLink>
              <span v-else>{{
                item.title.toLocaleDateString(locale, props.options.date)
              }}</span>
            </td>
            <td v-else>
              <NuxtLink
                v-if="item.url"
                :to="localePath(item.url)"
              >
                {{ item.title }}
              </NuxtLink>
            </td>
            <td v-if="item.subtitle && item.subtitle instanceof Date">
              {{
                item.subtitle.toLocaleDateString(locale, props.options.date)
              }}
            </td>
            <td v-else-if="item.subtitle && !isNaN(item.subtitle)">
              {{ item.subtitle }}<span>{{ props.options.unit }}
              </span>
            </td>
            <td v-else-if="item.subtitle">
              {{ item.subtitle }}
            </td>
            <td>
              <span
                v-if="props.options.unit === '&deg;F'"
                v-html="convert('F', item.value, 0)"
              />
              <span
                v-else
              ><span v-html="item.value" />{{ options.unit }}
              </span>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card-text>
    <v-card-text
      v-if="props.footer"
      class="text-caption text-wrap ma-0 pa-3"
    >
      <span v-html="props.footer" />
    </v-card-text>
  </v-card>
</template>

<style scoped lang="scss"></style>
